import { render, staticRenderFns } from "./HomeRecommendCruise.vue?vue&type=template&id=6f2b9596&scoped=true"
import script from "./HomeRecommendCruise.vue?vue&type=script&lang=js"
export * from "./HomeRecommendCruise.vue?vue&type=script&lang=js"
import style0 from "./HomeRecommendCruise.vue?vue&type=style&index=0&id=6f2b9596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b9596",
  null
  
)

export default component.exports